import { Tooltip } from '@shared/components/popover/tooltip';
import type { Product } from '../../../data/product';
import { StatusCell } from '../../status/status-cell';

export function ItemCodeCell({ product }: { product: Product }) {
  const code = product.item_code || product.suggested_item_code;
  if (!code) {
    return null;
  }

  if (!product.item_code) {
    return (
      <Tooltip
        content={`${product.suggested_item_code} is suggested from pricing & other store's data. Set it in LiquorPOS to lock it in.`}
      >
        <StatusCell variant="attention">{code}</StatusCell>
      </Tooltip>
    );
  }

  return <span className="px-1 py-0.5">{code}</span>;
}
